import React, { useState, useEffect } from "react";
import axios from "axios";
import { REACT_APP_API_URL } from "../../../../env";

function ItemCategory() {

  const [data, setData] = useState([]);
  const [mode, setMode] = useState("view");
  const [showModal, setShowModal] = useState(false);
  const [editId, setEditId] = useState(null);

  const [form, setForm] = useState({
    CategoryName: "",
    Description: ""
  });

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    const res = await axios.post(`${REACT_APP_API_URL}api/inventory/item`, {
      action: "CAT_V"
    });
    setData(res.data);
  };
  const handleSubmit = async (e) => {

  e.preventDefault();

  // TRIM VALUES
  const categoryName = form.CategoryName.trim();
  const description = form.Description.trim();

  // REQUIRED VALIDATION
  if (!categoryName) {
    alert("Category Name is required");
    return;
  }

  // MIN LENGTH
  if (categoryName.length < 3) {
    alert("Category Name must be at least 3 characters");
    return;
  }

  // ONLY TEXT + SPACE
  const nameRegex = /^[A-Za-z\s]+$/;

  if (!nameRegex.test(categoryName)) {
    alert("Only alphabets allowed in Category Name");
    return;
  }

  // SCRIPT VALIDATION
  const scriptRegex = /<script.*?>.*?<\/script>/gi;

  if (scriptRegex.test(categoryName)) {
    alert("Invalid input detected");
    return;
  }

  if (scriptRegex.test(description)) {
    alert("Invalid description");
    return;
  }

  // DUPLICATE CHECK
  const duplicate = data.some(
    (d) =>
      d.ItemCategoryName.toLowerCase() === categoryName.toLowerCase() &&
      d.ItemCategoryId !== editId
  );

  if (duplicate) {
    alert("Category already exists");
    return;
  }

  try {

    const action = editId ? "CAT_U" : "CAT_A";

    await axios.post(
      `${REACT_APP_API_URL}api/inventory/item`,
      {
        action,
        ItemCategoryId: editId || 0,
        ItemCategoryName: categoryName,
        Description: description
      }
    );

    alert(editId ? "Updated Successfully" : "Added Successfully");

    resetForm();
    loadData();

  } catch (error) {

    console.error(error);
    alert("Something went wrong");
  }
};
  const handleEdit = (item) => {

    setEditId(item.ItemCategoryId);

    setForm({
      CategoryName: item.ItemCategoryName,
      Description: item.Description
    });

    setShowModal(true);
  };
  const handleDelete = async (id) => {

    if (!window.confirm("Delete this category?")) return;

    await axios.post(`${REACT_APP_API_URL}api/inventory/item`, {
      action: "CAT_D",
      ItemCategoryIds: String(id)
    });

    alert("Deleted");
    loadData();
  };
  const resetForm = () => {
    setForm({ CategoryName: "", Description: "" });
    setEditId(null);
    setShowModal(false);
  };

  return (
    <div className="container-fluid p-4">
      <div className="card p-3">
        <div className="mb-3">
          <button
            className={`btn ${mode === "add" ? "btn-primary" : "btn-outline-primary"} me-2`}
            onClick={() => setMode("add")}
          >
            Add
          </button>          
          <button
            className={`btn ${mode === "view" ? "btn-primary" : "btn-outline-primary"}`}
            onClick={() => setMode("view")}
          >
            View
          </button>
        </div>
        {mode === "add" && (
          <div className="text-center">
            <button
              className="btn btn-success"
              onClick={() => {
                resetForm();
                setShowModal(true);
              }}
            >
              + Add Category
            </button>            
          </div>
        )}        
        {mode === "view" && (
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>#</th>
                <th>Category Name</th>
                <th>Description</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {data.map((d, i) => (
                <tr key={d.ItemCategoryId}>
                  <td>{i + 1}</td>
                  <td>{d.ItemCategoryName}</td>
                  <td>{d.Description}</td>
                  <td>
                    <button
                      className="btn btn-sm btn-primary me-2"
                      onClick={() => handleEdit(d)}
                    >
                      ✏️
                    </button>
                    <button
                      className="btn btn-sm btn-danger"
                      onClick={() => handleDelete(d.ItemCategoryId)}
                    >
                      🗑️
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
      {showModal && (
        <>
          <div className="modal d-block">
            <div className="modal-dialog">
              <div className="modal-content p-3">

                <div className="modal-header">
                  <h5>{editId ? "Edit Category" : "Add Category"}</h5>
                  <button className="btn-close" onClick={resetForm}></button>
                </div>

                <form onSubmit={handleSubmit}>
                 <input
                      className="form-control mb-2"
                      placeholder="Category Name"
                      maxLength={50}
                      value={form.CategoryName}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (/^[A-Za-z\s]*$/.test(value)) {
                          setForm({
                            ...form,
                            CategoryName: value
                          });
                        }
                      }}
                      required
                    />
                  <textarea
                      className="form-control mb-2"
                      placeholder="Description"
                      maxLength={200}
                      value={form.Description}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (/^[A-Za-z\s]*$/.test(value)) {

                          setForm({
                            ...form,
                            Description: value
                          });
                        }
                      }}
                    />                      
                  <button className="btn btn-success w-100">
                    {editId ? "Update" : "Submit"}
                  </button>

                </form>

              </div>
            </div>
          </div>

          <div className="modal-backdrop show"></div>
        </>
      )}

    </div>
  );
}

export default ItemCategory;